import { Component, Input, OnInit } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { Observable } from 'rxjs';
import { LayoutService, TitleToolbar } from 'src/app/core/service/layout.service';
import { localDB } from 'src/app/shared/helpers/localStorage';
import { ToolbarUserComponent } from './components/toolbar-user/toolbar-user.component';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';

@Component({
  selector: 'mg-toolbar',
  imports: [ToolbarUserComponent, IconComponent],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss'
})
export class ToolbarComponent implements OnInit {
  @Input() isDesktop: boolean | null = null;
  @Input() sidenav: MatSidenav | null = null;
  public title: TitleToolbar | null = null;

  isScreenSMD$ : Observable<boolean> | null = null;
  isDesktop$: Observable<boolean> | null = null;
  isMainDashboard$: Observable<boolean> | null = null;

    constructor(
      private _layoutService: LayoutService
    ) { }

  ngOnInit(): void {
    // this.ObtainMarksInterval();
    
    this.isScreenSMD$ = this._layoutService.isScreenMD$;
    this.isDesktop$ = this._layoutService.isScreenXL$;
    this.isMainDashboard$ = this._layoutService.currentRouteObservable;
    this._layoutService.titleToolbar$.subscribe((titleConfig) => {
      this.title = titleConfig;
    });
  }

}
